import { create } from "zustand";

const ZustandSelectBankType = create((set, get) => ({

  selectInter: "Multibancos",
  setSelectInter: (value) => set({ selectInter: value || "Multibancos" }),
  disableSelectInter : false,
  setDisableSelectdInter: (value) => set({ disableSelectInter : value }),
}));

export default ZustandSelectBankType;
